import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ImFacebook2 } from "react-icons/im";
import { MdLeaderboard } from "react-icons/md";
import FaceBookLoginButton from "./FaceBookLoginButton";
import { axiosApiInstance } from "../../app/axios";
import { API_URL } from "../../app/config";
import IconComponent from "../../components/common/IconComponent";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Button } from "@progress/kendo-react-buttons";
import { disConnectFacebook } from "./services/integration.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { Checkbox } from "@progress/kendo-react-inputs";

const Integrations: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [lgFBToken, setLgFBToken] = useState(localStorage.getItem("FBTOKEN"));
  const [accesstoken, setAccessToken] = useState<any>();
  const [FBUserID, setFBUserID] = useState<string>();
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  const handleConsentChange = (event: any) => {
    setIsConsentChecked(event.value);
  };

  const handleOpenDisconnectDialog = () => {
    dispatch(openDialog("disconnectFacebook"));
  };

  useEffect(() => {
    const passFBToken = async () => {
      if (accesstoken) {
        const response = await axiosApiInstance.post(
          `${API_URL}/webhook/WebHookToken`,
          {
            WebHookToken: accesstoken,
            FBUserID: FBUserID,
          }
        );
        if (response.data.Status === 200 && response.data.Data?.WebHookToken) {
          localStorage.setItem(
            "FBTOKEN",
            response.data.Data?.WebHookToken || ""
          );
          setLgFBToken(response.data.Data?.WebHookToken);
        }
      }
    };
    passFBToken();
  }, [accesstoken]);

  return (
    <GridLayout
      style={{ marginRight: 20 }}
      gap={{ cols: 10, rows: 0 }}
      cols={[{ width: "33.33%" }, { width: "33.33%" }, { width: "33.33%" }]}
    >
      <GridLayoutItem
        colSpan={3}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 0px 20px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          FB/Insta Lead Integrations
        </Typography.h4>
        {lgFBToken && (
          <button
            className="facebook-button"
            onClick={() => handleOpenDisconnectDialog()}
            style={{ backgroundColor: "#f31700" }}
          >
            Disconnect
          </button>
        )}
        <FacebookDisconnectDialog setLgFBToken={setLgFBToken} />
      </GridLayoutItem>
      <GridLayoutItem colSpan={3} className="d-flex gap-3">
        {!lgFBToken ? (
          <GridLayout
            style={{ marginRight: 20 }}
            gap={{ cols: 10, rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              Allow Meta access to display your leads in CRM.
            </GridLayoutItem>
            <div style={{ marginTop: "16px" }}>
              <div style={{ marginBottom: "12px" }}>
                <Typography.p style={{ fontSize: "14px", margin: "0" }}>
                  By connecting your Facebook account, you agree to our{" "}
                  <a
                    href="https://aseuminfotech.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1d4ed8", textDecoration: "underline" }}
                  >
                    Privacy Policy
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://aseuminfotech.com/terms-conditions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#1d4ed8", textDecoration: "underline" }}
                  >
                    Terms & Conditions
                  </a>
                  . We will access your Facebook Pages and lead data as
                  described in our privacy policy.
                </Typography.p>
              </div>

              <div>
                <Checkbox
                  label={
                    "I have read and agree to the Privacy Policy and Terms & Conditions"
                  }
                  checked={isConsentChecked}
                  onChange={handleConsentChange}
                  size={"medium"}
                  labelClassName="k-form-label"
                  style={{ borderColor: "#888282" }}
                />
              </div>
            </div>

            <GridLayoutItem>
              <FaceBookLoginButton
                setAccessToken={setAccessToken}
                setFBUserID={setFBUserID}
                isConsentChecked={isConsentChecked}
              />
            </GridLayoutItem>
          </GridLayout>
        ) : (
          <>
            <div className="integration-menu-card">
              <div
                className="integration-menu-poster"
                onClick={() => navigate("/integrations/facebook")}
              >
                <IconComponent
                  icon={ImFacebook2}
                  className="integration-menu-icon"
                />
              </div>
              <p className="m-0 text-center">
                Facebook <br />
                Integration
              </p>
            </div>
            <div className="integration-menu-card">
              <div
                className="integration-menu-poster"
                onClick={() => navigate("/integrations/leadcenter")}
              >
                <IconComponent
                  icon={MdLeaderboard}
                  className="integration-menu-icon"
                />
              </div>
              <p className="m-0 text-center">
                Facebook <br />
                Lead Center
              </p>
            </div>
          </>
        )}
      </GridLayoutItem>
    </GridLayout>
  );
};

interface FBDisconnectDialogProps {
  setLgFBToken: (token: string) => void;
}

const FacebookDisconnectDialog: React.FC<FBDisconnectDialogProps> = ({
  setLgFBToken,
}) => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.integration.loading);

  const gridRef = useRef<any>(null);

  const handleDisconnectAction = async () => {
    try {
      const FBUserID = localStorage.getItem("FBUserID");

      if (FBUserID) {
        const response = await dispatch(disConnectFacebook(FBUserID));

        if (response.meta.requestStatus === "fulfilled") {
          localStorage.removeItem("FBTOKEN");
          localStorage.removeItem("FBUserID");
          setLgFBToken("");
          dispatch(closeDialog());
        }
      }
    } catch (error) {
      console.error("Error disconnecting Facebook:", error);
      dispatch(closeDialog());
    }
  };

  return (
    <>
      {dialogName === "disconnectFacebook" && (
        <AppDialog className="fb-disconnect-dialog">
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5>{"Disconnect Facebook Account?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to disconnect your Facebook account from
                  our CRM?
                </Typography.p>
              </GridLayoutItem>

              <GridLayoutItem>
                <div
                  style={{
                    backgroundColor: "#fffbeb",
                    border: "1px solid #fde68a",
                    borderRadius: "8px",
                    padding: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <Typography.p
                    style={{
                      color: "#92400e",
                      fontWeight: "600",
                      marginBottom: "12px",
                    }}
                  >
                    ⚠ This action will have the following effects:
                  </Typography.p>
                  <ul
                    style={{
                      color: "#92400e",
                      fontSize: "14px",
                      paddingLeft: "20px",
                      margin: "0",
                    }}
                  >
                    <li style={{ marginBottom: "8px" }}>
                      All your current page integrations will be disconnected
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      New leads from Facebook will stop flowing into your CRM
                    </li>
                  </ul>
                </div>
              </GridLayoutItem>

              <GridLayoutItem>
                <div
                  style={{
                    backgroundColor: "#eff6ff",
                    border: "1px solid #bfdbfe",
                    borderRadius: "8px",
                    padding: "12px",
                    marginBottom: "16px",
                  }}
                >
                  <Typography.p
                    style={{
                      fontSize: "14px",
                      color: "#1e40af",
                      margin: "0",
                    }}
                  >
                    <strong>Note:</strong> Your existing lead data in the CRM
                    will remain safe and accessible.
                  </Typography.p>
                </div>
              </GridLayoutItem>

              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" text="No" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={handleDisconnectAction}
                  type="button"
                  className="ms-2"
                  disabled={loading}
                >
                  Yes, Disconnect
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Integrations;
